import type { UserData } from '@/server/user';
import { CHAINS } from './constants';
import type { Chain } from './constants';

/**
 * Type guard function to check if a chain is valid
 *
 * @param chain
 * @returns true if the chain is valid, false otherwise
 */
export function isValidChain(chain: string | undefined): chain is Chain {
  return CHAINS.includes(chain as Chain);
}

/**
 * Get valid chain from local storage, user's active chain or first chain from user's chains array
 *
 * Default to 'intersport' if no valid chain is found
 */
export function getValidChainOrDefault(localActiveChain: string | undefined, user: UserData) {
  // The chaining in `user?.user?.chains` is important since we force the user to be at least {} in initial state
  const userChains = user?.user?.chains;

  // If user is not initialized, return default
  if (!userChains) {
    return 'intersport';
  }

  const allowedChains = userChains.map((chain) => chain.id);

  // Check local active chain
  if (isValidChain(localActiveChain) && allowedChains.includes(localActiveChain)) {
    return localActiveChain;
  }

  // Check first chain from user's chains array
  const firstUserChain = userChains[0]?.id;
  if (isValidChain(firstUserChain)) {
    return firstUserChain;
  }

  // Default to 'intersport' if no valid chain is found
  return 'intersport';
}
